import i from "./Components/NcActionButton.mjs";
import m from "./Components/NcActionButtonGroup.mjs";
import e from "./Components/NcActionCaption.mjs";
import p from "./Components/NcActionCheckbox.mjs";
import c from "./Components/NcActionInput.mjs";
import f from "./Components/NcActionLink.mjs";
import n from "./Components/NcActionRadio.mjs";
import N from "./Components/NcActionRouter.mjs";
import a from "./Components/NcActions.mjs";
import s from "./Components/NcActionSeparator.mjs";
import l from "./Components/NcActionText.mjs";
import u from "./Components/NcActionTextEditable.mjs";
import d from "./Components/NcAppContent.mjs";
import A from "./Components/NcAppContentDetails.mjs";
import g from "./Components/NcAppContentList.mjs";
import b from "./Components/NcAppNavigation.mjs";
import S from "./Components/NcAppNavigationCaption.mjs";
import x from "./Components/NcAppNavigationIconBullet.mjs";
import T from "./Components/NcAppNavigationItem.mjs";
import v from "./Components/NcAppNavigationNew.mjs";
import C from "./Components/NcAppNavigationNewItem.mjs";
import I from "./Components/NcAppNavigationSettings.mjs";
import k from "./Components/NcAppNavigationSpacer.mjs";
import h from "./Components/NcAppSettingsDialog.mjs";
import B from "./Components/NcAppSettingsSection.mjs";
import P from "./Components/NcAppSidebar.mjs";
import y from "./Components/NcAppSidebarTab.mjs";
import { N as D } from "./chunks/index-efb07851.mjs";
import { u as tt } from "./chunks/index-efb07851.mjs";
import O from "./Components/NcBreadcrumb.mjs";
import R from "./Components/NcBreadcrumbs.mjs";
import j from "./Components/NcButton.mjs";
import E from "./Components/NcCheckboxRadioSwitch.mjs";
import M from "./Components/NcColorPicker.mjs";
import _ from "./Components/NcContent.mjs";
import L from "./Components/NcCounterBubble.mjs";
import F from "./Components/NcDashboardWidget.mjs";
import w from "./Components/NcDashboardWidgetItem.mjs";
import z from "./Components/NcDateTime.mjs";
import G from "./Components/NcDateTimePicker.mjs";
import W from "./Components/NcDateTimePickerNative.mjs";
import H from "./Components/NcDialog.mjs";
import V from "./Components/NcDialogButton.mjs";
import K from "./Components/NcEmojiPicker.mjs";
import U from "./Components/NcEmptyContent.mjs";
import $ from "./Components/NcGuestContent.mjs";
import q from "./Components/NcHeaderMenu.mjs";
import { N as J } from "./chunks/index-20a9ace9.mjs";
import Q from "./Components/NcIconSvgWrapper.mjs";
import X from "./Components/NcListItem.mjs";
import Y from "./Components/NcListItemIcon.mjs";
import Z from "./Components/NcLoadingIcon.mjs";
import oo from "./Components/NcModal.mjs";
import ro from "./Components/NcNoteCard.mjs";
import to from "./Components/NcPasswordField.mjs";
import io from "./Components/NcPopover.mjs";
import mo from "./Components/NcProgressBar.mjs";
import eo from "./Components/NcRelatedResourcesPanel.mjs";
import { N as po } from "./chunks/index-5f2a5f57.mjs";
import { r as mt } from "./chunks/index-5f2a5f57.mjs";
import co, { NcAutoCompleteResult as fo } from "./Components/NcRichContenteditable.mjs";
import { N as no } from "./chunks/NcRichText-0db09c78.mjs";
import "./chunks/referencePickerModal-ded8273d.mjs";
import "@nextcloud/axios";
import "@nextcloud/router";
import No from "./Components/NcSelect.mjs";
import "./chunks/l10n-1b905a9a.mjs";
import ao from "./Components/NcTextField.mjs";
import "@nextcloud/event-bus";
import "vue";
import so from "./Components/NcSavingIndicatorIcon.mjs";
import lo from "./Components/NcSelectTags.mjs";
import uo from "./Components/NcSettingsInputText.mjs";
import Ao from "./Components/NcSettingsSection.mjs";
import { N as go } from "./chunks/NcSettingsSelectGroup-cdd84895.mjs";
import bo from "./Components/NcTimezonePicker.mjs";
import So from "./Components/NcUserBubble.mjs";
import xo from "./Components/NcTextArea.mjs";
import { isFullscreenState as pt, useIsFullscreen as ct } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT as nt, isMobileState as Nt, useIsMobile as at } from "./Composables/useIsMobile.mjs";
import { emojiAddRecent as lt, emojiSearch as ut } from "./Functions/emoji.mjs";
import { default as At } from "./Functions/usernameToColor.mjs";
import { directive as To } from "./Directives/Focus.mjs";
import { directive as vo } from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as bt } from "./Mixins/clickOutsideOptions.mjs";
import { default as xt } from "./Mixins/isFullscreen.mjs";
import { default as vt } from "./Mixins/isMobile.mjs";
import { VTooltip as Co } from "floating-vue";
import { VTooltip as It } from "floating-vue";
/**
 * @copyright Copyright (c) 2018 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const Io = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton: i,
  NcActionButtonGroup: m,
  NcActionCaption: e,
  NcActionCheckbox: p,
  NcActionInput: c,
  NcActionLink: f,
  NcActionRadio: n,
  NcActionRouter: N,
  NcActionSeparator: s,
  NcActionText: l,
  NcActionTextEditable: u,
  NcActions: a,
  NcAppContent: d,
  NcAppContentDetails: A,
  NcAppContentList: g,
  NcAppNavigation: b,
  NcAppNavigationCaption: S,
  NcAppNavigationIconBullet: x,
  NcAppNavigationItem: T,
  NcAppNavigationNew: v,
  NcAppNavigationNewItem: C,
  NcAppNavigationSettings: I,
  NcAppNavigationSpacer: k,
  NcAppSettingsDialog: h,
  NcAppSettingsSection: B,
  NcAppSidebar: P,
  NcAppSidebarTab: y,
  NcAutoCompleteResult: fo,
  NcAvatar: D,
  NcBreadcrumb: O,
  NcBreadcrumbs: R,
  NcButton: j,
  NcCheckboxRadioSwitch: E,
  NcColorPicker: M,
  NcContent: _,
  NcCounterBubble: L,
  NcDashboardWidget: F,
  NcDashboardWidgetItem: w,
  NcDateTime: z,
  NcDateTimePicker: G,
  NcDateTimePickerNative: W,
  NcDialog: H,
  NcDialogButton: V,
  NcEmojiPicker: K,
  NcEmptyContent: U,
  NcGuestContent: $,
  NcHeaderMenu: q,
  NcHighlight: J,
  NcIconSvgWrapper: Q,
  NcListItem: X,
  NcListItemIcon: Y,
  NcLoadingIcon: Z,
  NcMentionBubble: po,
  NcModal: oo,
  NcNoteCard: ro,
  NcPasswordField: to,
  NcPopover: io,
  NcProgressBar: mo,
  NcRelatedResourcesPanel: eo,
  NcRichContenteditable: co,
  NcRichText: no,
  NcSavingIndicatorIcon: so,
  NcSelect: No,
  NcSelectTags: lo,
  NcSettingsInputText: uo,
  NcSettingsSection: Ao,
  NcSettingsSelectGroup: go,
  NcTextArea: xo,
  NcTextField: ao,
  NcTimezonePicker: bo,
  NcUserBubble: So
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @copyright 2022 Christopher Ng <chrng8@gmail.com>
 *
 * @author Christopher Ng <chrng8@gmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const Yr = (o) => o.type === "click" || o.type === "keydown" && o.key === "Enter";
/**
 * @copyright Copyright (c) 2018 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const ko = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: To,
  Linkify: vo,
  Tooltip: Co
}, Symbol.toStringTag, { value: "Module" })), Zr = {
  install(o) {
    Object.entries(Io).forEach(([t, r]) => {
      o.component(r.name || t, r);
    }), Object.entries(ko).forEach(([t, r]) => {
      o.directive(t, r);
    });
  }
};
export {
  To as Focus,
  vo as Linkify,
  nt as MOBILE_BREAKPOINT,
  i as NcActionButton,
  m as NcActionButtonGroup,
  e as NcActionCaption,
  p as NcActionCheckbox,
  c as NcActionInput,
  f as NcActionLink,
  n as NcActionRadio,
  N as NcActionRouter,
  s as NcActionSeparator,
  l as NcActionText,
  u as NcActionTextEditable,
  a as NcActions,
  d as NcAppContent,
  A as NcAppContentDetails,
  g as NcAppContentList,
  b as NcAppNavigation,
  S as NcAppNavigationCaption,
  x as NcAppNavigationIconBullet,
  T as NcAppNavigationItem,
  v as NcAppNavigationNew,
  C as NcAppNavigationNewItem,
  I as NcAppNavigationSettings,
  k as NcAppNavigationSpacer,
  h as NcAppSettingsDialog,
  B as NcAppSettingsSection,
  P as NcAppSidebar,
  y as NcAppSidebarTab,
  fo as NcAutoCompleteResult,
  D as NcAvatar,
  O as NcBreadcrumb,
  R as NcBreadcrumbs,
  j as NcButton,
  E as NcCheckboxRadioSwitch,
  M as NcColorPicker,
  _ as NcContent,
  L as NcCounterBubble,
  F as NcDashboardWidget,
  w as NcDashboardWidgetItem,
  z as NcDateTime,
  G as NcDateTimePicker,
  W as NcDateTimePickerNative,
  H as NcDialog,
  V as NcDialogButton,
  K as NcEmojiPicker,
  U as NcEmptyContent,
  $ as NcGuestContent,
  q as NcHeaderMenu,
  J as NcHighlight,
  Q as NcIconSvgWrapper,
  X as NcListItem,
  Y as NcListItemIcon,
  Z as NcLoadingIcon,
  po as NcMentionBubble,
  oo as NcModal,
  ro as NcNoteCard,
  to as NcPasswordField,
  io as NcPopover,
  mo as NcProgressBar,
  eo as NcRelatedResourcesPanel,
  co as NcRichContenteditable,
  no as NcRichText,
  so as NcSavingIndicatorIcon,
  No as NcSelect,
  lo as NcSelectTags,
  uo as NcSettingsInputText,
  Ao as NcSettingsSection,
  go as NcSettingsSelectGroup,
  xo as NcTextArea,
  ao as NcTextField,
  bo as NcTimezonePicker,
  So as NcUserBubble,
  Zr as NextcloudVuePlugin,
  It as Tooltip,
  bt as clickOutsideOptions,
  lt as emojiAddRecent,
  ut as emojiSearch,
  Yr as isA11yActivation,
  xt as isFullscreen,
  pt as isFullscreenState,
  vt as isMobile,
  Nt as isMobileState,
  mt as richEditor,
  ct as useIsFullscreen,
  at as useIsMobile,
  tt as userStatus,
  At as usernameToColor
};
